import { Controller } from "@hotwired/stimulus"

// Disclosure controller for collapsible sections
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.updateState()
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    this.openValue = !this.openValue
    this.updateState()
  }

  updateState() {
    if (!this.hasContentTarget) {
      return
    }
    
    if (this.openValue) {
      this.contentTarget.classList.remove("hidden")
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("rotate-180")
      }
    } else {
      this.contentTarget.classList.add("hidden")
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("rotate-180")
      }
    }
  }
}



